import '../sass/styles.scss';
import Modal from 'bootstrap/js/dist/modal';
import Glide, { Breakpoints, Controls, Swipe, Autoplay } from '@glidejs/glide/dist/glide.modular.esm';

window.jQuery = $;
window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
	if ($('.slider').length) {
		let answers = new Glide('.slider', {
			type: 'carousel',
			autoplay: 5000,
			animationDuration: 350,
			gap: 0,
			perView: 3,
			focusAt: 'center',
			dragThreshold: true,
			breakpoints: {
				768: {
					perView: 1,
				},
			},
		}).mount({
			Controls,
			Breakpoints,
			Swipe,
			Autoplay,
		});
	}

	gformSettings();

	$(document).bind('gform_post_render', function () {
		gformSettings();
	});

	function gformSettings() {
		// Prevent checking checkbox when opening rules modal
		$('.rules-link').click(function (e) {
			e.preventDefault();
		});
	}

	// Show Sanoma Media CMP
	$('body').on('click', '#cookiesetup', function () {
		utag.link({ event_name: 'cmp_privacy_manager', event_action: 'show' });
	});

	// Init thanks modal
	const thanks = new Modal(document.getElementById('thanks'), {
		keyboard: false,
		backdrop: 'static',
	});

	$(document).on('gform_confirmation_loaded', function () {
		// Trigger GA event
		if (typeof dataLayer !== 'undefined' && dataLayer) {
			dataLayer.push({
				event: 'CampaignEvent',
				eventCategory: 'osallistuminen',
				eventAction: 'lomake',
				eventLabel: 'lähetetty',
			});
		}

		$('.form-container').hide();

		thanks.show();

		// Redirect after 5 seconds
		var delay = 5000;
		var url = 'https://www.eckes-granini.fi/tuotteet/godmorgon/shot/';
		setTimeout(function () {
			window.location = url;
		}, delay);
	});

	// Scroll to first error field on validation error
	$(document).on('gform_post_render', function (event, formId) {
		var $form = jQuery('#gform_' + formId);
		var $firstError = $form.find('.gfield_error:first');

		if ($firstError.length) {
			$('html, body').animate(
				{
					scrollTop: $firstError.offset().top - 100,
				},
				800,
			);
		}
	});

	const storyInput = document.getElementById('input_1_10');
	const storyMinChars = 100;
	const storyMaxChars = 350;

	function getStoryLength() {
		return storyInput ? storyInput.value.trim().length : 0;
	}

	function setupStoryValidation() {

		const textarea = storyInput;
		const helper = document.querySelector('.storyhelper');

		if (!textarea || !helper) {
			return;
		}

		const updateHelper = () => {
			const length = getStoryLength();

			let message;
			if (length === 0) {
				message = `Kirjoita vähintään ${storyMinChars} merkkiä`;
			} else if (length < storyMinChars) {
				message = `Vielä ${storyMinChars - length} merkkiä minimimäärään`;
			} else if (length <= storyMaxChars) {
				message = `${length} / ${storyMaxChars} merkkiä`;
			} else {
				message = `Liikaa merkkejä (${length - storyMaxChars} yli rajan)`;
			}

			helper.textContent = message;
			helper.classList.toggle('error', length > storyMaxChars || (length > 0 && length < storyMinChars));
			helper.classList.toggle('success', length >= storyMinChars && length <= storyMaxChars);
		};

		textarea.addEventListener('input', updateHelper);

		updateHelper();
	}

	setupStoryValidation();

	// textarea update
	$('#input_1_10').on('input', function () {
		$(this).val($(this).val());
	});

	$('#gform_1').on('submit', function (e) {

		const storyLength = getStoryLength();
		const hasText = storyLength >= storyMinChars && storyLength <= storyMaxChars;

		$('.custom-gf-error').remove();

		// change to vanillajs
		document.querySelector('.storyhelper').classList.remove('error');

		if (!hasText) {
			e.stopImmediatePropagation();
			window['gf_submitting_1'] = false;

			$('#gform_1').prepend(
				`<div class="custom-gf-error gform_validation_errors">Lisää teksti (${storyMinChars}–${storyMaxChars} merkkiä) tai kuva.</div>`
			);

			document.querySelector('.storyhelper').classList.add('error');
			return false;
		}
	});
});
